module.exports = __webpack_public_path__ + "static/media/red-cross.dced12d1.svg";